module.exports = __webpack_public_path__ + "static/img/1.f84f9e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/1.jpg
// module id = PyGf
// module chunks = 1